<template>
    <div class="brick" @click="$emit('click', $event)" @mouseup="$emit('mouseup', $event)">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'brick-base'
    }
</script>